import React from "react";
import { useParams } from "react-router-dom";
import { PageHero } from "../components/FormKit";

const POLICIES = {
  privacy: { title: "Privacy Policy", body: [
    "TAVEN SYSTEM LLC (\"TAVEN\", \"we\", \"us\") respects your privacy. This policy explains what information we collect, how we use it, and your choices.",
    "Information We Collect: We collect information you provide through forms (name, email, phone, and application details) and basic usage data needed to operate the marketplace.",
    "How We Use It: To respond to inquiries, process applications and requests, send updates you opt into, and improve our services.",
    "Data Protection: We apply reasonable safeguards to protect your data and do not sell your personal information.",
    "Your Choices: You may request access to or deletion of your data by contacting us through the Contact page.",
  ]},
  shipping: { title: "Shipping Policy", body: [
    "Orders placed through the TAVEN marketplace are fulfilled through our secure commerce backend.",
    "Processing Time: Orders are typically processed within 1–3 business days.",
    "Delivery Estimates: Estimated delivery is 7–15 business days depending on destination and product.",
    "Tracking: Where available, tracking details are provided after your order ships.",
    "International Shipping: Availability, duties, and taxes vary by destination and are calculated at checkout.",
  ]},
  return: { title: "Return Policy", body: [
    "We want you to be satisfied with your purchase.",
    "Return Window: Approved returns are generally accepted within the applicable return window from delivery.",
    "Condition: Items must be unused, in original packaging, and in resalable condition unless defective.",
    "Process: Contact support to request a return authorization before shipping any item back.",
    "Exclusions: Certain items may be non-returnable for hygiene or final-sale reasons.",
  ]},
  refund: { title: "Refund Policy", body: [
    "Refunds are issued in accordance with this policy and marketplace terms.",
    "Eligibility: Approved refunds apply to eligible returned items or qualifying order issues.",
    "Timing: Once approved, refunds are processed to the original payment method within standard processing times.",
    "Partner Subscriptions: Pro E-Commerce Partner subscription fees are subject to their specific terms.",
    "Contact: For refund requests, please reach out through the Contact page.",
  ]},
  "earnings-disclaimer": { title: "Earnings Disclaimer", body: [
    "TAVEN SYSTEM LLC does not guarantee any specific level of income or earnings.",
    "Any earnings or income statements are estimates only. There is no assurance you will do as well.",
    "Results Vary: Affiliate and partner results depend on individual effort, skill, dedication, and market conditions.",
    "Risk: Participation in any business or affiliate opportunity involves risk. No income is promised or guaranteed.",
    "You are solely responsible for your actions and results.",
  ]},
  terms: { title: "Terms of Service", body: [
    "By using the TAVEN marketplace, you agree to these Terms of Service.",
    "Use of Service: You agree to use the site lawfully and not to misuse forms, accounts, or content.",
    "Accounts & Programs: Affiliate and seller programs are subject to their own terms, compliance rules, and approval.",
    "Products & Orders: Product availability, pricing, taxes, and shipping are managed through our commerce backend and may change.",
    "Limitation of Liability: TAVEN is not liable for indirect or incidental damages to the extent permitted by law.",
    "Changes: We may update these terms; continued use constitutes acceptance.",
  ]},
};

export const PolicyPage = () => {
  const { slug } = useParams();
  const policy = POLICIES[slug] || { title: "Policy", body: ["This policy is being prepared."] };
  return (
    <div data-testid="policy-page">
      <PageHero eyebrow="Legal & Compliance" title={policy.title} />
      <section className="py-14 px-4 md:px-8 lg:px-12 mx-auto max-w-3xl space-y-5">
        {policy.body.map((p) => <p key={p.slice(0, 32)} className="text-muted-foreground leading-relaxed">{p}</p>)}
        <p className="text-xs text-muted-foreground border-t border-black/10 pt-4 mt-8">TAVEN SYSTEM LLC — Build. Earn. Grow. Leave a Legacy.</p>
      </section>
    </div>
  );
};

export default PolicyPage;
